import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';

import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Testimonial from './components/Testimonial';
import CTA from './components/CTA';
import Footer from './components/Footer';
import Prices from './components/Prices';
function App() {
  return (
    <>
      <Header />
      <Hero />
      <Prices />
      <Testimonial />
      <Services />
      <CTA />
      <Footer />
    </>
  );
}

export default App;
